import { createApiSlice } from "@common";
import { CRUD_SERVICE, GET_SERVICE_BY_INTEGRATION } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addService",
    method: "post",
    url: CRUD_SERVICE,
    stateKey: "message",
  },
  {
    name: "getServiceByIntegration",
    method: "get",
    url: GET_SERVICE_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "updateService",
    method: "put",
    url: CRUD_SERVICE,
    stateKey: "message",
  },
  {
    name: "deleteService",
    method: "delete",
    url: CRUD_SERVICE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "integrationService",
  apiConfig,
  customReducers,
);
const integrationServiceSlice = slice;
// Export the slice's reducer
export default integrationServiceSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addService,
  getServiceByIntegration,
  updateService,
  deleteService,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect, } =
  actions;
